<template>
  <div class="fixed-header">
    <img
      class="logo"
      src="@/assets/images/header/logo.png"
      alt=""
    >
    <userInfo
      @changePsw="changePsw"
    />
    <changePswDialog
      :dialog-visible.sync="dialogVisible"
      @confirm="changePswSuccess"
    />
  </div>
</template>
<script>
import userInfo from './userInfo.vue';
import changePswDialog from '../common/changePswDialog.vue';

export default {
  name: 'FixedHeader',
  components: { userInfo, changePswDialog },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    // 打开修改密码弹窗
    changePsw() {
      this.dialogVisible = true;
    },
    // 修改密码成功
    changePswSuccess() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.fixed-header {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 4;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 6px 0 rgb(32 33 36 / 28%);
  // background: linear-gradient(0deg, #f9f9f9 0%, rgba($--base-color-black, 0.01) 100%);
  .logo {
    height: 60px;
  }
}
</style>
